import { FC, ReactElement } from 'react';

import { EvLink } from '@evinced-private/ui-common';

interface IEvChartTableLinkProps {
	value: string;
	onClick: () => void;
	customLink: ReactElement;
	ariaLabel?: string;
}

export const MobileChartTableLink: FC<IEvChartTableLinkProps> = ({
	onClick,
	value,
	ariaLabel,
	customLink
}) => {
	return (
		<EvLink
			url="#"
			ariaLabel={ariaLabel || value}
			isDark
			onClick={onClick}
			customLink={customLink}
		/>
	);
};
